const imgPath = '/static/images/about/v2/products/';

export type TProduct = {
    id: number,
    title: string,
    text: string,
    img: string,
    imgWebp: string,
    imgAlt: string,
    btnLink: string,
    btnText: string,
}

type DataKey = 'internet' | 'tv' | 'movix' | 'videocontrol' | 'domofon';

type TProductsData = {
    [key in DataKey]: TProduct;
}

export const productsData: TProductsData = {
    internet: {
        id: 1,
        title: 'Интернет для квартиры и частного дома',
        text: 'Подключаем высокоскоростной интернет до&nbsp;1&nbsp;Гбит/с. Круглосуточно проверяем качество связи каждые 30&nbsp;секунд 24/7 благодаря современной ' +
        'системе мониторинга.',
        img: imgPath + '1-internet.png',
        imgWebp: imgPath + '1-internet.webp',
        imgAlt: 'Изображение интернета для квартиры и частного дома',
        btnLink: '/internet/equipment',
        btnText: 'Выбрать роутер',
    },
    tv: {
        id: 2,
        title: 'Цифровое ТВ',
        text: 'У&nbsp;вас будет свой домашний кинотеатр. Современная ТВ-приставка и&nbsp;видеосервис Movix&nbsp;&mdash; это интерактивное телевидение, фильмы, сериалы ' +
        'и&nbsp;анимация из&nbsp;популярных онлайн-кинотеатров, игры, приложения и&nbsp;многое другое в&nbsp;едином удобном интерфейсе.',
        img: imgPath + '2-tv.png',
        imgWebp: imgPath + '2-tv.webp',
        imgAlt: 'Изображение цифрового телевидения',
        btnLink: '/internet/giga-movix',
        btnText: 'Выбрать тариф',
    },
    movix: {
        id: 3,
        title: 'Наборы развлечений для дома',
        text: 'Онлайн-кинотеатры, ТВ-подписки, пакеты телеканалов, сервисы с&nbsp;играми и&nbsp;книгами. Подключать и&nbsp;отключать их&nbsp;можно ' +
        'в&nbsp;личном кабинете на&nbsp;сайте или в&nbsp;мобильном приложении.',
        img: imgPath + '3-movix.png',
        imgWebp: imgPath + '3-movix.webp',
        imgAlt: 'Изображение онлайн кинотеатра',
        btnLink: '/movix-new',
        btnText: 'Перейти на сайт Movix',
    },
    videocontrol: {
        id: 4,
        title: 'Система видеонаблюдения',
        text: 'Реагирует на&nbsp;движения и&nbsp;сообщает, если кто-то проник внутрь. Управляется через приложение.',
        img: imgPath + '4-videocontrol.png',
        imgWebp: imgPath + '4-videocontrol.webp',
        imgAlt: 'Изображение система видеонаблюдения',
        btnLink: '/videocontrol ',
        btnText: 'Подробнее',
    },
    domofon: {
        id: 5,
        title: 'Видеодомофон',
        text: 'Смотрите, кто пришёл, открывайте дверь одним кликом и&nbsp;настраивайте гостевой доступ для пяти близких.',
        img: imgPath + '5-domofon.png',
        imgWebp: imgPath + '5-domofon.webp',
        imgAlt: 'Изображение видеодомофона',
        btnLink: '/domofon',
        btnText: 'Подробнее',
    },
 };
